import { Calendar } from 'react-calendar'
import { styled } from '../../Styles/stitches.config'

export const StyledCalendar = styled(Calendar, {
    //navigation
    '.react-calendar__navigation': {
        display: 'flex',

        '.react-calendar__navigation__arrow, .react-calendar__navigation__label':
            {
                bgc: 'transparent',
                border: 'none',
                br: '$1',
                color: '$black',
                fontSize: 20,
                fontWeight: 600,
                transition: '$default',
                p: '$2 $3',

                '&:not(:disabled):hover': {
                    bgc: '$neutral100',
                    cursor: 'pointer',
                },
            },
    },

    '.react-calendar__navigation__label': {
        textTransform: 'capitalize',
    },

    //weekday-view
    '.react-calendar__month-view__weekdays': {
        '.react-calendar__month-view__weekdays__weekday': {
            color: '$black',
            py: '$2',
            textAlign: 'center',
        },

        abbr: {
            fontWeight: 600,
            textDecoration: 'none',
            textTransform: 'uppercase',
        },
    },

    '.react-calendar__month-view__weekNumbers': {
        color: '$neutral500',
        flexBasis: '0 !important',
        fontSize: 10,
        fontWeight: 600,
        mt: 40,
        mr: '$1',
        zIndex: 1,
    },

    '.react-calendar__month-view--weekNumbers > div': {
        alignItems: 'normal !important',
    },

    '.react-calendar__month-view__weekNumbers > div': {
        justifyContent: 'center',
        display: 'grid',
        alignContent: 'top',
    },

    '.react-calendar__decade-view__years__year, .react-calendar__year-view__months__month, .react-calendar__month-view__days__day':
        {
            bgc: 'transparent',
            border: 'none',
            color: '$primary600',
            cursor: 'pointer',
            fontSize: 18,
            fontWeight: 600,

            '&:not(:disabled):hover': {
                color: '$white',
            },
        },

    '.react-calendar__decade-view__years, .react-calendar__year-view__months': {
        display: 'grid !important',
        gridAutoFlow: 'dense',
        gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))',
        gap: '$1',

        '&__year, &__month': {
            br: '1000px',
            border: '2px solid transparent',
            py: '$2',
            transition: '$default',

            '&:not(:disabled):hover': {
                bgc: '$neutral100',
                border: '2px solid $primary600',
                color: '$primary600',
            },
        },
    },

    '.react-calendar__month-view__days__day': {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        p: '$1 0',
        position: 'relative',

        '&--now': {
            color: '$white',

            abbr: {
                bgc: '$primary600',
            },
        },

        '&:not(.firstWeek)': {
            borderTop: '1px solid $neutral200',
        },

        '&:not(:disabled):hover': {
            abbr: {
                bgc: '$white',
                border: '2px solid $primary600',
                color: '$primary600',
            },
        },

        abbr: {
            alignItems: 'center',
            border: '2px solid transparent',
            br: '50%',
            display: 'flex',
            justifyContent: 'center',
            size: 48,
            transition: '$default',
        },
    },

    '.week-view': {
        '.react-calendar:navigation': {
            '.react-calendar__navigation__arrow': {
                color: '#ccc',
                pointerEvents: 'none',
            },
        },
    },
})
